import React from 'react'
import Layout from '../components/Layout'

/**
 * The top-level wrapper for gatsby-plugin-layout.
 *
 * This exists so that `<Layout />` will not be destroyed
 * and recreated, keeping the state persistent across different pages.
 *
 * See:
 * https://www.gatsbyjs.org/packages/gatsby-plugin-layout/
 */

const TopLevelWrapper = props => {
  const { children } = props

  // props.pageResources.page.path
  const pageResources = props.pageResources || {}
  const pageResource = pageResources.page || {}
  const pagePath = pageResource.path

  switch (pagePath) {
    case '/styleguides/':
      return <>{children}</>

    case '/':
      // Home page
      return (
        <Layout path={pagePath} compact>
          {children}
        </Layout>
      )

    default:
      return <Layout path={pagePath}>{children}</Layout>
  }
}

/*
interface Props {
  path: string // => '/*'
  '*': string //  => 'agile.html'
  uri: string //  => '/agile.html'
  location: {
    href: string
    origin: string
    protocol: string
  }
  navigate: any
  pageContext: any
  pageResources: {
    component: React.ComponentClass
    page: {
      componentChunkName: string // 'component--src-pages-home-js'
      path: string // '/styleguides/'
    }
  }
  data: any // markdownRemark, ...
}
*/

export default TopLevelWrapper
